export enum OneTimePasswordType {
	MemberInfo = 'member_info',
}

type ApiCreateOneTimePasswordResponse = {
	type: OneTimePasswordType;
	id: string;
	token: string;
	urlToken: string;
};

export default ApiCreateOneTimePasswordResponse;
